<script>
// Marco honesto para un bloque sin datos: conserva cabecera y espacio, explica y (opcional) ofrece una acción.
export default {
  name: "DashEmpty",
  props: {
    title: { type: String, required: true },
    text: { type: String, default: "" },
    compact: { type: Boolean, default: false },
    minHeight: { type: Number, default: 0 },
  },
};
</script>

<template>
  <div class="dsh-empty" :class="{ 'dsh-empty--compact': compact }" :style="minHeight ? { minHeight: minHeight + 'px' } : null">
    <p class="dsh-empty__title">{{ title }}</p>
    <p v-if="text" class="dsh-empty__text">{{ text }}</p>
    <slot />
  </div>
</template>
